import { FieldDto } from '@core/service/digital-factory/bank/types/bankDto';

export enum ConnectionStateEnum {
  VALID = 'valid',
  SCA = 'sca',
  DECOUPLED = 'decoupled',
  MORE_INFORMATION = 'moreInformation',
  ACTION_NEEDED = 'actionNeeded',
  ERROR = 'error',
  PASSWORD_EXPIRED = 'passwordExpired',
  VALIDATING = 'validating',
  WEBAUTH_REQUIRED = 'webauthRequired',
}

export type ConnectionResponseDto = {
  id: string;
  userId: string;
  bank: {
    id: string;
    name: string;
  };
  state: ConnectionStateEnum;
  form?: FieldDto[];
};
